import { z } from "zod";
import { RegionCustomEnum } from "@/constants/enums/regionCustom.enum";
import { i18nMessage } from "@/lib/i18nMessage";

export const customWineValueTaxRangesSchema = z.object({
  from: z
    .number({ coerce: true, message: i18nMessage("validation:requiredField") })
    .min(0, i18nMessage("validation:requiredField")),
  to: z
    .number({ coerce: true, message: i18nMessage("validation:requiredField") })
    .min(0, i18nMessage("validation:requiredField")),
  value: z
    .number({ coerce: true, message: i18nMessage("validation:requiredField") })
    .min(0, i18nMessage("validation:requiredField")),
});

export const customAdditionalRequestsSchema = z.object({
  title: z.string().min(1, i18nMessage("validation:requiredField")),
  description: z.string().min(1, i18nMessage("validation:requiredField")),
});

export const bottleTransportPricesSchema = z.object({
  amount: z
    .number({ coerce: true, message: i18nMessage("validation:requiredField") })
    .min(0, i18nMessage("validation:requiredField")),
  quantity: z
    .number({ coerce: true, message: i18nMessage("validation:requiredField") })
    .min(0, i18nMessage("validation:requiredField")),
});

export const CustomTarifSchema = z.object({
  id: z.string().min(1, i18nMessage("validation:requiredField")),
  label: z.string().min(1, i18nMessage("validation:requiredField")),
  bottleTransportPrices: z.array(bottleTransportPricesSchema),
});

export const CustomSchema = z.object({
  id: z.string().optional(),
  label: z.string().min(1, i18nMessage("boCustoms:customForm.labelRequired")),
  countryCode: z.array(z.string().min(1, i18nMessage("validation:requiredField"))),
  flagCode: z
    .string({ message: i18nMessage("boCustoms:customForm.countryRequired") })
    .min(1, i18nMessage("boCustoms:customForm.countryRequired")),
  country: z.string().optional(),
  taxPerShipment: z
    .number({ coerce: true, message: i18nMessage("boCustoms:customForm.taxInvalid") })
    .min(0, i18nMessage("boCustoms:customForm.taxMin")),
  wineValueTaxPercentage: z
    .number({ coerce: true, message: i18nMessage("boCustoms:customForm.taxInvalid") })
    .min(0, i18nMessage("boCustoms:customForm.taxMin")),
  taxPerBottle: z
    .number({ coerce: true, message: i18nMessage("boCustoms:customForm.taxInvalid") })
    .min(0, i18nMessage("boCustoms:customForm.taxMin")),
  taxPerLiter: z
    .number({ coerce: true, message: i18nMessage("boCustoms:customForm.taxInvalid") })
    .min(0, i18nMessage("boCustoms:customForm.taxMin")),
  transportPlusWineValueTaxPercentage: z
    .number({ coerce: true, message: i18nMessage("boCustoms:customForm.taxInvalid") })
    .min(0, i18nMessage("boCustoms:customForm.taxMin")),
  transportPlusWinePlusInsuranceTaxPercentage: z
    .number({ coerce: true, message: i18nMessage("boCustoms:customForm.taxInvalid") })
    .min(0, i18nMessage("boCustoms:customForm.taxMin")),
  bottleMaxPerShipment: z
    .number({ coerce: true, message: i18nMessage("boCustoms:customForm.valueInvalid") })
    .min(0, i18nMessage("boCustoms:customForm.valueInvalid"))
    .optional(),
  maxPurchaseValue: z
    .number({ coerce: true, message: i18nMessage("boCustoms:customForm.valueInvalid") })
    .min(0, i18nMessage("boCustoms:customForm.valuePositive"))
    .optional(),
  vatPercentage: z
    .number({ coerce: true, message: i18nMessage("boCustoms:customForm.taxMin") })
    .min(0, i18nMessage("boCustoms:customForm.taxMin")),
  recipientChargeTaxes: z.boolean(),
  euTarifs: z.boolean(),
  usaCustomInvoice: z.boolean(),
  customWineValueTaxRanges: z.array(customWineValueTaxRangesSchema),
  customAdditionalRequests: z.array(customAdditionalRequestsSchema),
  customTarifs: z.array(CustomTarifSchema),
  isCustomQuotationOnly: z.boolean(),
  region: z.nativeEnum(RegionCustomEnum, {
    message: i18nMessage("boCustoms:customForm.regionRequired"),
  }),
});

export type CustomFormData = z.infer<typeof CustomSchema>;
